import { httpInterceptor } from '../http-interceptor';

export class QualityApprovalService {
  static ENDPOINTS = {
    GET_ALL: 'Mobile/partsbystatus',
    GET_ALL_APPROVALS: 'Mobile/getPartsForApproveOrReject',   
    CREATE: 'qualityapproval/createqualityapproval',
    APPROVE_REJECT: 'InspectionPlan/requeststatusChange',
    REQUEST_EVIDENCE: 'InspectionPlan/saverequestevidence',
    PARTS: 'mobile/parts',
    DELETE: 'shipment/delete',
    GET_BY_ID: 'InspectionPlan/getrequestbypartid',
    EXTEND: 'qualityapproval/extendqualityapproval',
  };

  static async getAllQualityApproval(data) {
    return httpInterceptor.get(this.ENDPOINTS.GET_ALL, data);
  }
    static async getAllApprovals(data) {
      return httpInterceptor.get(this.ENDPOINTS.GET_ALL_APPROVALS,data);
    }
  static async approveRejectQualityApproval(data) {
    return httpInterceptor.post(this.ENDPOINTS.APPROVE_REJECT, data);
  }

  static async requestEvidence(data) {
    return httpInterceptor.post(this.ENDPOINTS.REQUEST_EVIDENCE, data);
  }

  static async getQualityApprovalById(id) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_BY_ID}/${id}`);
  }

  static async createQualityApproval(data) {
    return httpInterceptor.post(this.ENDPOINTS.CREATE, data);
  }
  static async getParts() {
    return httpInterceptor.get(`${this.ENDPOINTS.PARTS}`);
  }
  static async extendQualityApproval(data) {
    return httpInterceptor.post(this.ENDPOINTS.EXTEND, data);
  }
}
